import { CeAlign } from "../../generic/components/form-fields/ce-align";
import { CeColourField } from "../../generic/components/form-fields/ce-colour-field";
import { CeTextInput } from "../../generic/components/form-fields/ce-text-field";
import { FormStack } from "../../generic/components/form-fields/form-stack";

import type { EmailDesignSchema } from "../../email-design/types/email-design-type";
import type { FC } from "react";

export const HeaderTextSettingsEditor: FC = () => (
  <FormStack>
    <CeAlign<EmailDesignSchema> analyticsCategory="email_design" name="header.text.align" />
    <CeTextInput<EmailDesignSchema>
      analyticsCategory="email_design"
      name="header.text.value"
      label="Header Text"
    />
    <CeColourField<EmailDesignSchema>
      analyticsCategory="email_design"
      name="header.text.color"
      label="Header Text Color"
    />
  </FormStack>
);
